import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const EnergyLeafGlyph = /*#__PURE__*/createElement("g", {
  id: "energy_leaf",
  transform: "scale(3.5)",
  fill: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M5.14611 10.8C4.34611 12.4 3.94611 14.2 4.04611 15.9C3.94611 17.4 4.54611 18.9 5.54611 20.1C6.54611 21.2 8.04611 21.9 9.54611 22C13.0461 22 15.0461 20 15.0461 17V10.5M15.0461 10.5C12.5461 10.5 10.5461 8.5 10.5461 6V4.5C10.5461 4.2 10.7461 4 11.0461 4H19.0461C19.3461 4 19.5461 4.2 19.5461 4.5V6C19.5461 8.5 17.5461 10.5 15.0461 10.5ZM12.5461 4V1M17.5461 4V1M0.646128 13.1C0.146128 15 0.846128 16.7 4.04613 16C6.64613 18.2 7.84613 17.1 8.44613 15C8.94613 13 7.64613 9.3 5.74613 7.5C5.64613 7.3 5.44613 7.3 5.34613 7.3C5.14613 7.3 5.04613 7.4 4.94613 7.6C3.64613 9.9 1.24613 10.9 0.646128 13.1Z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const EnergyLeaf = createSvg({
  name: 'energy_leaf',
  path: EnergyLeafGlyph
});

export default EnergyLeaf;
export { EnergyLeafGlyph };
